import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { Loader } from "arv-reactcomponents";

import AddAddress from "../AddAddress";
import AddressList from "../../AddressList";

@inject("AddressStore")
@observer
class ReturnAddress extends Component {

  constructor(props) {
    super(props);
    this.state = {
      currentView: "addressList",
      addressObject: {},
      addressId: "",
      edit: false,
    };
    this.removeAddress = this.removeAddress.bind(this);
    this.setAddressDefault = this.setAddressDefault.bind(this);
    this.showEditAddress = this.showEditAddress.bind(this);
    this.showAddAddress = this.showAddAddress.bind(this);
    this.onAddressSave = this.onAddressSave.bind(this);
    this.previous = this.previous.bind(this);
  }

  get addressList() {
    return this.props.AddressStore.userAddresses;
  }

  showEditAddress(addressObject) {
    this.setState({
      currentView: "addAddress",
      addressObject,
      addressId: addressObject.id,
      edit: true,
    });
  }
  showAddAddress() {
    this.setState({
      currentView: "addAddress",
      addressObject: {},
      addressId: "",
      edit: false,
    });
  }

  onAddressSave(addAddressDetails, addressId, edit) {
    let promise;
    if (edit && addressId) {
      promise = this.props.AddressStore.editAddress(
        addAddressDetails,
        addressId,
        true,
      );
    } else {
      promise = this.props.AddressStore.addAddressCall(
        addAddressDetails,
        true,
        true,
      );
    }
    this.setState({ loader: true });
    promise
      .then(res => {
        this.previous();
      })
      .catch(err => {
        this.previous();
      });
  }

  previous(e) {
    this.setState({ loader: false });
    if (e) e.preventDefault();
    const { currentView } = this.state;
    if (currentView === "addAddress")
      this.setState({
        currentView: "addressList",
        addressObject: null,
        addressId: "",
        edit: false,
      });
    if (currentView === "addressList") this.props.previous(e);
  }

  removeAddress(addressId) {
    this.props.AddressStore.removeAddress(addressId).then(
      () => {
        this.props.AddressStore.getUserAddresses(true);
      },
      () => {
        console.log("Error from remove address API");
      },
    );
  }

  setAddressDefault(addressId) {
    this.props.AddressStore.setAddressDefault(addressId).then(
      () => {
        this.props.AddressStore.getUserAddresses(true);
      },
      () => {
        console.log("Error from set address default API");
      },
    );
  }

  get addressView() {
    const { currentView, addressObject, addressId, edit } = this.state;
    const { inner, previous, setReversePickAddress } = this.props;
    switch (currentView) {
      case "addressList":
        return (
          <AddressList.component
            addresses={this.addressList}
            forReturns
            addAddress={this.showAddAddress}
            onAddressSelection={setReversePickAddress}
            onEditClick={this.showEditAddress}
            onRemoveAddress={this.removeAddress}
            onSetAddressDefault={this.setAddressDefault}
            showBackButton
            previous={previous}
          />
        );
      case "addAddress":
        return (
          <AddAddress.component
            edit={edit}
            editableAddress={addressObject}
            onAddressSave={this.onAddressSave}
            previous={this.previous}
            showBackButton
            showLocalLoader={this.state.loader}
          />
        );
      default:
        return (
          <AddressList.component
            addresses={this.addressList}
            forReturns
            inner={this.showAddAddress}
            onAddressSelection={setReversePickAddress}
            onEditClick={this.showEditAddress}
            onRemoveAddress={this.removeAddress}
            onSetAddressDefault={this.setAddressDefault}
            showBackButton
            previous={previous}
          />
        );
    }
  }

  render() {
    return (
      <Fragment>
        {this.addressView}
      </Fragment>
    );
  }
}

ReturnAddress.wrappedComponent.propTypes = {
  AddressStore: PropTypes.shape({
    addressloader: PropTypes.bool,
    getUserAddresses: PropTypes.func,
    removeAddress: PropTypes.func,
    setAddressDefault: PropTypes.func,
    userAddresses: PropTypes.shape({}),
  }).isRequired,
  previous: PropTypes.func.isRequired,
  setReversePickAddress: PropTypes.func.isRequired,
};

const getFinalComponent = component =>
  inject("AddressStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ReturnAddress.wrappedComponent,
  component: ReturnAddress,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ReturnComponent/ReturnAddress/index.js